import { api } from 'store/queries';

export const hotelApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCountryList: build.query({
            query: () => ({ url: '/country/list', method: 'get' }),
            overrideExisting: true,
        }),
        getCountry: build.query({
            query: (countrySlug) => ({
                url: `/country/get/${countrySlug}`,
                method: 'get',
            }),
            transformResponse: (response) => response.data,
            overrideExisting: true,
        }),
        getCountryDestinations: build.query({
            query: (countrySlug) => ({
                url: `/destination/list/country/${countrySlug}`,
                method: 'get',
            }),
            overrideExisting: true,
        }),
        getDestination: build.query({
            query: ({ countrySlug, destinationSlug }) => ({
                url: `/destination/get/${countrySlug}/${destinationSlug}`,
                method: 'get',
            }),
            transformResponse: (response) => response.data,
            overrideExisting: true,
        }),
        getResort: build.query({
            query: ({ countrySlug, destinationSlug, resortSlug }) => ({
                url: `/resort/get/${countrySlug}/${destinationSlug}/${resortSlug}`,
                method: 'get',
            }),
            transformResponse: (response) => response.data,
            overrideExisting: true,
        }),
        getProperty: build.query({
            query: ({ countrySlug, destinationSlug, propertySlug }) => ({
                url: `/property/path/${countrySlug}/${destinationSlug}/${propertySlug}`,
                method: 'get',
            }),
            overrideExisting: true,
        }),
        getDestinationResorts: build.query({
            query: ({ countrySlug, destinationSlug }) => ({
                url: `/resort/list/country/${countrySlug}/destination/${destinationSlug}`,
                method: 'get',
            }),
            overrideExisting: true,
        }),
        getResortProperties: build.query({
            query: ({ countrySlug, destinationSlug, resortSlug }) => ({
                url: `/property/list/country/${countrySlug}/destination/${destinationSlug}/resort/${resortSlug}`,
                method: 'get',
            }),
            overrideExisting: true,
        }),
    }),
});

export const {
    useGetCountryListQuery,
    useGetCountryQuery,
    useGetCountryDestinationsQuery,
    useGetDestinationQuery,
    useGetDestinationResortsQuery,
    useGetResortQuery,
    useGetResortPropertiesQuery,
    useGetPropertyQuery,
} = hotelApi;
